import { createForOfIteratorHelper as _createForOfIteratorHelper } from '../_virtual/_rollupPluginBabelHelpers.mjs';
import { useCallback } from 'react';

/**
 * @description 여러 개의 ref를 하나로 합치고 싶을 때 사용할 수 있는 hook입니다.
 *
 * ```ts
 * function useCombinedRefs<T>(...refs: Array<Ref<T> | CallbackRef<T>>): Ref<T>;
 * ```
 *
 * @example
 * const SomeComponent = forwardRef((props, parentRef) => {
 *   const myRef = useRef(null);
 *   const ref = useCombinedRefs(myRef, parentRef);
 *
 *   // 하단 div가 업데이트되면 myRef와 parentRef 모두가 업데이트됨
 *   return <div ref={ref} />;
 * })
 */
function useCombinedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return useCallback(function (value) {
    var _iterator = _createForOfIteratorHelper(refs),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ref = _step.value;

        if (typeof _ref === 'function') {
          _ref(value);
        } else if (_ref != null) {
          _ref.current = value;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  refs);
}

export { useCombinedRefs };
